/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ReactElement, useState } from 'react';

const useMultiStepForm = (steps: ReactElement[]) => {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  const nextStep = () => {
    setCurrentStepIndex(index => {
      if (index >= steps.length - 1) {
        return index;
      }
      return index + 1;
    });
  };

  const backStep = () => {
    setCurrentStepIndex(index => {
      if (index <= 0) {
        return index;
      }
      return index - 1;
    });
  };

  const goToStep = (step: number) => {
    setCurrentStepIndex(step);
  };

  return {
    steps,
    step: steps[currentStepIndex],
    currentStepIndex,
    nextStep,
    backStep,
    goToStep,
    isFirstStep: currentStepIndex === 0,
    isLastStep: currentStepIndex >= steps.length - 1,
  };
};

export default useMultiStepForm;
